var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSustainableGmp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1654 18.9583C29.1654 26.25 24.0612 29.8958 17.9945 32.0104C17.6769 32.1181 17.3318 32.1129 17.0174 31.9958C10.9362 29.8958 5.83203 26.25 5.83203 18.9583V8.75C5.83203 8.36323 5.98568 7.9923 6.25917 7.71881C6.53266 7.44532 6.90359 7.29167 7.29036 7.29167C10.207 7.29167 13.8529 5.54167 16.3904 3.325C16.6993 3.06104 17.0923 2.91602 17.4987 2.91602C17.9051 2.91602 18.2981 3.06104 18.607 3.325C21.1591 5.55625 24.7904 7.29167 27.707 7.29167C28.0938 7.29167 28.4647 7.44532 28.7382 7.71881C29.0117 7.9923 29.1654 8.36323 29.1654 8.75V18.9583Z",
    stroke: "#D32F2F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 17.5002L16.0417 20.4168L21.875 14.5835",
    stroke: "#D32F2F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSustainableGmp);
export default __webpack_public_path__ + "static/media/Sustainable_GMP.13985c04eeb72024e322e941848f29bf.svg";
export { ForwardRef as ReactComponent };